// js/index.ts
var ColorActivityScrollHintLight = "#d9d9d9";
var ColorActivityScrollHintDark = "#2e2f30";
var ColorBackgroundMainLight = "#ffffff";
var ColorBackgroundMainDark = "#171819";
var ColorBackgroundSecondaryLight = "#fafafa";
var ColorBackgroundSecondaryDark = "#232425";
var ColorBackgroundTertiaryLight = "#ffffff";
var ColorBackgroundTertiaryDark = "#2e2f30";
var ColorBackgroundBehindLight = "#f4f4f4";
var ColorBackgroundBehindDark = "#0c0c0d";
var ColorBackgroundCardTabLight = "#fafafa";
var ColorBackgroundCardTabDark = "#171819";
var ColorBackgroundPlaceholderLight = "#d9d9d9";
var ColorBackgroundPlaceholderDark = "#454647";
var ColorBackgroundElevatedLight = "#ffffff";
var ColorBackgroundElevatedDark = "#232425";
var ColorBackgroundElevatedSecondaryLight = "#fafafa";
var ColorBackgroundElevatedSecondaryDark = "#2e2f30";
var ColorButtonPrimaryBackgroundLight = "#00d64b";
var ColorButtonPrimaryBackgroundDark = "#00bd46";
var ColorButtonPrimaryTintLight = "#ffffff";
var ColorButtonPrimaryTintDark = "#ffffff";
var ColorButtonSecondaryBackgroundLight = "#f4f4f4";
var ColorButtonSecondaryBackgroundDark = "#454647";
var ColorButtonSecondaryTintLight = "#333333";
var ColorButtonSecondaryTintDark = "#ffffff";
var ColorButtonTertiaryTintLight = "#00d64b";
var ColorButtonTertiaryTintDark = "#00bd46";
var ColorButtonOutlineSelectedBorderLight = "#00d64b";
var ColorButtonOutlineSelectedBorderDark = "#00bd46";
var ColorButtonSegmentedControlForegroundLight = "#ffffff";
var ColorButtonSegmentedControlForegroundDark = "#454647";
var ColorButtonSegmentedControlBackgroundLight = "#f4f4f4";
var ColorButtonSegmentedControlBackgroundDark = "#232425";
var ColorButtonPageControlSelectedLight = "#333333";
var ColorButtonPageControlSelectedDark = "#ffffff";
var ColorButtonPageControlUnselectedLight = "#bfbfbf";
var ColorButtonPageControlUnselectedDark = "#747576";
var ColorCardStudioStampDeletionPillBackgroundLight = "#333333";
var ColorCardStudioStampDeletionPillBackgroundDark = "#333333";
var ColorIconDefaultLight = "#333333";
var ColorIconDefaultDark = "#ffffff";
var ColorIconSecondaryLight = "#666666";
var ColorIconSecondaryDark = "#a2a3a3";
var ColorIconTertiaryLight = "#999999";
var ColorIconTertiaryDark = "#747576";
var ColorIconPlaceholderLight = "#d9d9d9";
var ColorIconPlaceholderDark = "#454647";
var ColorIconDisabledLight = "#d9d9d9";
var ColorIconDisabledDark = "#5d5d5e";
var ColorIconChevronLight = "#d9d9d9";
var ColorIconChevronDark = "#747576";
var ColorIconDragHandleLight = "#d9d9d9";
var ColorIconDragHandleDark = "#747576";
var ColorInputCursorLight = "#00d64b";
var ColorInputCursorDark = "#00bd46";
var ColorInputClearButtonTintLight = "#bfbfbf";
var ColorInputClearButtonTintDark = "#454647";
var ColorInvestingPurpleLight = "#9013fe";
var ColorInvestingPurpleDark = "#b141ff";
var ColorInvestingPageControlUnselectedLight = "#bfbfbf";
var ColorInvestingPageControlUnselectedDark = "#747576";
var ColorInvestingPageControlSelectedLight = "#333333";
var ColorInvestingPageControlSelectedDark = "#333333";
var ColorInvestingBaselineStrokeLight = "#e5e5e5";
var ColorInvestingBaselineStrokeDark = "#454647";
var ColorInvestingGrayChartStrokeLight = "#bfbfbf";
var ColorInvestingGrayChartStrokeDark = "#747576";
var ColorInvestingScrubbingChartStrokeLight = "#d9d9d9";
var ColorInvestingScrubbingChartStrokeDark = "#454647";
var ColorInvestingCellAccessoryLightLight = "#f4f4f4";
var ColorInvestingCellAccessoryLightDark = "#747576";
var ColorInvestingCellAccessoryDarkLight = "#d9d9d9";
var ColorInvestingCellAccessoryDarkDark = "#454647";
var ColorInvestingSelectableLabelOutlineLight = "#f4f4f4";
var ColorInvestingSelectableLabelOutlineDark = "#454647";
var ColorInvestingCustomOrderTargetScreenBackgroundLight = "#f4f4f4";
var ColorInvestingCustomOrderTargetScreenBackgroundDark = "#171819";
var ColorInvestingCustomOrderTooltipBackgroundLight = "#ffffff";
var ColorInvestingCustomOrderTooltipBackgroundDark = "#333333";
var ColorInvestingDraggablePriceWidgetBackgroundLight = "#333333";
var ColorInvestingDraggablePriceWidgetBackgroundDark = "#333333";
var ColorInvestingDraggablePriceWidgetForegroundLight = "#fafafa";
var ColorInvestingDraggablePriceWidgetForegroundDark = "#171819";
var ColorLabelDefaultLight = "#333333";
var ColorLabelDefaultDark = "#ffffff";
var ColorLabelSecondaryLight = "#666666";
var ColorLabelSecondaryDark = "#a2a3a3";
var ColorLabelTertiaryLight = "#999999";
var ColorLabelTertiaryDark = "#747576";
var ColorLabelPlaceholderLight = "#bfbfbf";
var ColorLabelPlaceholderDark = "#747576";
var ColorLabelDisabledLight = "#bfbfbf";
var ColorLabelDisabledDark = "#5d5d5e";
var ColorHairlineLight = "#e5e5e5";
var ColorHairlineDark = "#2e2f30";
var ColorOutlineLight = "#d9d9d9";
var ColorOutlineDark = "#454647";
var ColorUnselectedPasscodeDotLight = "#e5e5e5";
var ColorUnselectedPasscodeDotDark = "#232425";
var ColorWidgetForegroundLight = "#000000";
var ColorWidgetForegroundDark = "#ffffff";
var ColorKeyboardLight = "#666666";
var ColorKeyboardDark = "#ffffff";
var ColorCardCustomizationStrokeLight = "#000000";
var ColorCardCustomizationStrokeDark = "#ffffff";
var ColorPaletteBlack = "#000000";
var ColorPaletteGray20 = "#333333";
var ColorPaletteGray40 = "#666666";
var ColorPaletteGray60 = "#999999";
var ColorPaletteGray75 = "#bfbfbf";
var ColorPaletteGray85 = "#d9d9d9";
var ColorPaletteGray90 = "#e5e5e5";
var ColorPaletteGray96 = "#f4f4f4";
var ColorPaletteGray98 = "#fafafa";
var ColorPaletteWhite = "#ffffff";
var ColorPaletteCobalt = "#171819";
var ColorPaletteCobalt5 = "#232425";
var ColorPaletteCobalt10 = "#2e2f30";
var ColorPaletteCobalt20 = "#454647";
var ColorPaletteCobalt30 = "#5d5d5e";
var ColorPaletteCobalt40 = "#747576";
var ColorPaletteCobalt60 = "#a2a3a3";
var ColorPaletteBehindCobalt = "#0c0c0d";
var ColorPaletteBgGreen = "#00b840";
var ColorPaletteLightModeGreen = "#00d64b";
var ColorPaletteDarkModeGreen = "#00bd46";
var ColorPaletteOnGreen = "#00c244";
var ColorPaletteAmber = "#f46e38";
var ColorPaletteOcean = "#3399ff";
var ColorPalettePink = "#fb60c4";
var ColorPalettePurple = "#b141ff";
var ColorPaletteRed = "#f84049";
var ColorPaletteRoyal = "#3f6aff";
var ColorPaletteScarlet = "#ff4a4a";
var ColorPaletteSky = "#00d4ff";
var ColorPaletteSteel = "#343b42";
var ColorPaletteSunshine = "#fada3d";
var ColorPaletteTurquoise = "#41ebc1";
var ColorPaletteBitcoinBlue = "#00d5ff";
var ColorPaletteBgBitcoinBlue = "#00c5f0";
var ColorPaletteInvestingPurpleLight = "#9013fe";
var ColorPaletteInvestingPurpleDark = "#b141ff";
var ColorPaymentPadBackgroundLight = "#00b840";
var ColorPaymentPadBackgroundDark = "#171819";
var ColorPaymentPadButtonBackgroundLight = "#00c244";
var ColorPaymentPadButtonBackgroundDark = "#454647";
var ColorPaymentPadGhostedTextLight = "#00c244";
var ColorPaymentPadGhostedTextDark = "#2e2f30";
var ColorPaymentPadKeyboardLight = "#ffffff";
var ColorPaymentPadKeyboardDark = "#ffffff";
var ColorPaymentPadBitcoinBackgroundLight = "#00c5f0";
var ColorPaymentPadBitcoinBackgroundDark = "#171819";
var ColorPaymentPadBitcoinButtonBackgroundLight = "#00d5ff";
var ColorPaymentPadBitcoinButtonBackgroundDark = "#454647";
var ColorTintGreenLight = "#00d64b";
var ColorTintGreenDark = "#00bd46";
var ColorTintVerificationLight = "#3399ff";
var ColorTintVerificationDark = "#3399ff";
var BreakpointMin = "320px";
var BreakpointSmall = "760px";
var BreakpointMedium = "1024px";
var BreakpointLarge = "1440px";
var BreakpointMax = "1680px";
var SpaceEmpty = "0";
var SpaceDefault = "1rem";
var SpaceXxs = "0.25rem";
var SpaceXs = "0.5rem";
var SpaceS = "0.75rem";
var SpaceM = "1rem";
var SpaceL = "1.5rem";
var SpaceXl = "2rem";
var SpaceXxl = "3rem";
var Space3xl = "6rem";
var Space4xl = "7.5rem";
var SpaceInsetDefault = "1rem 1rem 1rem 1rem";
var SpaceInsetXxs = "0.25rem 0.25rem 0.25rem 0.25rem";
var SpaceInsetXs = "0.5rem 0.5rem 0.5rem 0.5rem";
var SpaceInsetS = "0.75rem 0.75rem 0.75rem 0.75rem";
var SpaceInsetM = "1rem 1rem 1rem 1rem";
var SpaceInsetL = "1.5rem 1.5rem 1.5rem 1.5rem";
var SpaceInsetXl = "2rem 2rem 2rem 2rem";
var MotionCurveLongTail = "cubic-bezier(0, 0.3, 1, 0)";
var MotionCurveStandard = "cubic-bezier(0, 0.3, 1, 0.5)";
var MotionCurveSymmetrical = "cubic-bezier(0, 0.5, 1, 0.5)";
var TypographyFontRegular = "CashMarketRounded-Regular";
var TypographyFontMedium = "CashMarketRounded-Medium";
var TypographyRootFontSize = "16px";
var TypographyBigMoneyFontSize = "3.125rem";
var TypographyBigMoneyLineHeight = "4rem";
var TypographyBigMoneyFontWeight = "medium";
var TypographyBigMoneyLetterSpacing = "normal";
var TypographyHeader1FontSize = "2.5rem";
var TypographyHeader1LineHeight = "3rem";
var TypographyHeader1FontWeight = "bold";
var TypographyHeader1LetterSpacing = "normal";
var TypographyHeader2FontSize = "2rem";
var TypographyHeader2LineHeight = "2.5rem";
var TypographyHeader2FontWeight = "medium";
var TypographyHeader2LetterSpacing = "normal";
var TypographyHeader3FontSize = "1.5rem";
var TypographyHeader3LineHeight = "2rem";
var TypographyHeader3FontWeight = "medium";
var TypographyHeader3LetterSpacing = "0.01em";
var TypographyHeader4FontSize = "1.25rem";
var TypographyHeader4LineHeight = "1.75rem";
var TypographyHeader4FontWeight = "medium";
var TypographyHeader4LetterSpacing = "0.01em";
var TypographyInputFontSize = "1.25rem";
var TypographyInputLineHeight = "1.75rem";
var TypographyInputFontWeight = "regular";
var TypographyInputLetterSpacing = "0.01em";
var TypographyMainTitleFontSize = "1.125rem";
var TypographyMainTitleLineHeight = "1.5rem";
var TypographyMainTitleFontWeight = "medium";
var TypographyMainTitleLetterSpacing = "0.01em";
var TypographyMainBodyFontSize = "1.125rem";
var TypographyMainBodyLineHeight = "1.5rem";
var TypographyMainBodyFontWeight = "regular";
var TypographyMainBodyLetterSpacing = "0.01em";
var TypographySmallTitleFontSize = "1rem";
var TypographySmallTitleLineHeight = "1.5rem";
var TypographySmallTitleFontWeight = "medium";
var TypographySmallTitleLetterSpacing = "0.01em";
var TypographySmallBodyFontSize = "1rem";
var TypographySmallBodyLineHeight = "1.5rem";
var TypographySmallBodyFontWeight = "regular";
var TypographySmallBodyLetterSpacing = "0.01em";
var TypographyStrongCaptionFontSize = "0.875rem";
var TypographyStrongCaptionLineHeight = "1.25rem";
var TypographyStrongCaptionFontWeight = "medium";
var TypographyStrongCaptionLetterSpacing = "0.01em";
var TypographyCaptionFontSize = "0.875rem";
var TypographyCaptionLineHeight = "1.25rem";
var TypographyCaptionFontWeight = "regular";
var TypographyCaptionLetterSpacing = "0.01em";
var TypographyIdentifierFontSize = "0.75rem";
var TypographyIdentifierLineHeight = "1rem";
var TypographyIdentifierFontWeight = "medium";
var TypographyIdentifierLetterSpacing = "0.12em";
var TypographyIdentifierTextTransform = "uppercase";
export {
  BreakpointLarge,
  BreakpointMax,
  BreakpointMedium,
  BreakpointMin,
  BreakpointSmall,
  ColorActivityScrollHintDark,
  ColorActivityScrollHintLight,
  ColorBackgroundBehindDark,
  ColorBackgroundBehindLight,
  ColorBackgroundCardTabDark,
  ColorBackgroundCardTabLight,
  ColorBackgroundElevatedDark,
  ColorBackgroundElevatedLight,
  ColorBackgroundElevatedSecondaryDark,
  ColorBackgroundElevatedSecondaryLight,
  ColorBackgroundMainDark,
  ColorBackgroundMainLight,
  ColorBackgroundPlaceholderDark,
  ColorBackgroundPlaceholderLight,
  ColorBackgroundSecondaryDark,
  ColorBackgroundSecondaryLight,
  ColorBackgroundTertiaryDark,
  ColorBackgroundTertiaryLight,
  ColorButtonOutlineSelectedBorderDark,
  ColorButtonOutlineSelectedBorderLight,
  ColorButtonPageControlSelectedDark,
  ColorButtonPageControlSelectedLight,
  ColorButtonPageControlUnselectedDark,
  ColorButtonPageControlUnselectedLight,
  ColorButtonPrimaryBackgroundDark,
  ColorButtonPrimaryBackgroundLight,
  ColorButtonPrimaryTintDark,
  ColorButtonPrimaryTintLight,
  ColorButtonSecondaryBackgroundDark,
  ColorButtonSecondaryBackgroundLight,
  ColorButtonSecondaryTintDark,
  ColorButtonSecondaryTintLight,
  ColorButtonSegmentedControlBackgroundDark,
  ColorButtonSegmentedControlBackgroundLight,
  ColorButtonSegmentedControlForegroundDark,
  ColorButtonSegmentedControlForegroundLight,
  ColorButtonTertiaryTintDark,
  ColorButtonTertiaryTintLight,
  ColorCardCustomizationStrokeDark,
  ColorCardCustomizationStrokeLight,
  ColorCardStudioStampDeletionPillBackgroundDark,
  ColorCardStudioStampDeletionPillBackgroundLight,
  ColorHairlineDark,
  ColorHairlineLight,
  ColorIconChevronDark,
  ColorIconChevronLight,
  ColorIconDefaultDark,
  ColorIconDefaultLight,
  ColorIconDisabledDark,
  ColorIconDisabledLight,
  ColorIconDragHandleDark,
  ColorIconDragHandleLight,
  ColorIconPlaceholderDark,
  ColorIconPlaceholderLight,
  ColorIconSecondaryDark,
  ColorIconSecondaryLight,
  ColorIconTertiaryDark,
  ColorIconTertiaryLight,
  ColorInputClearButtonTintDark,
  ColorInputClearButtonTintLight,
  ColorInputCursorDark,
  ColorInputCursorLight,
  ColorInvestingBaselineStrokeDark,
  ColorInvestingBaselineStrokeLight,
  ColorInvestingCellAccessoryDarkDark,
  ColorInvestingCellAccessoryDarkLight,
  ColorInvestingCellAccessoryLightDark,
  ColorInvestingCellAccessoryLightLight,
  ColorInvestingCustomOrderTargetScreenBackgroundDark,
  ColorInvestingCustomOrderTargetScreenBackgroundLight,
  ColorInvestingCustomOrderTooltipBackgroundDark,
  ColorInvestingCustomOrderTooltipBackgroundLight,
  ColorInvestingDraggablePriceWidgetBackgroundDark,
  ColorInvestingDraggablePriceWidgetBackgroundLight,
  ColorInvestingDraggablePriceWidgetForegroundDark,
  ColorInvestingDraggablePriceWidgetForegroundLight,
  ColorInvestingGrayChartStrokeDark,
  ColorInvestingGrayChartStrokeLight,
  ColorInvestingPageControlSelectedDark,
  ColorInvestingPageControlSelectedLight,
  ColorInvestingPageControlUnselectedDark,
  ColorInvestingPageControlUnselectedLight,
  ColorInvestingPurpleDark,
  ColorInvestingPurpleLight,
  ColorInvestingScrubbingChartStrokeDark,
  ColorInvestingScrubbingChartStrokeLight,
  ColorInvestingSelectableLabelOutlineDark,
  ColorInvestingSelectableLabelOutlineLight,
  ColorKeyboardDark,
  ColorKeyboardLight,
  ColorLabelDefaultDark,
  ColorLabelDefaultLight,
  ColorLabelDisabledDark,
  ColorLabelDisabledLight,
  ColorLabelPlaceholderDark,
  ColorLabelPlaceholderLight,
  ColorLabelSecondaryDark,
  ColorLabelSecondaryLight,
  ColorLabelTertiaryDark,
  ColorLabelTertiaryLight,
  ColorOutlineDark,
  ColorOutlineLight,
  ColorPaletteAmber,
  ColorPaletteBehindCobalt,
  ColorPaletteBgBitcoinBlue,
  ColorPaletteBgGreen,
  ColorPaletteBitcoinBlue,
  ColorPaletteBlack,
  ColorPaletteCobalt,
  ColorPaletteCobalt10,
  ColorPaletteCobalt20,
  ColorPaletteCobalt30,
  ColorPaletteCobalt40,
  ColorPaletteCobalt5,
  ColorPaletteCobalt60,
  ColorPaletteDarkModeGreen,
  ColorPaletteGray20,
  ColorPaletteGray40,
  ColorPaletteGray60,
  ColorPaletteGray75,
  ColorPaletteGray85,
  ColorPaletteGray90,
  ColorPaletteGray96,
  ColorPaletteGray98,
  ColorPaletteInvestingPurpleDark,
  ColorPaletteInvestingPurpleLight,
  ColorPaletteLightModeGreen,
  ColorPaletteOcean,
  ColorPaletteOnGreen,
  ColorPalettePink,
  ColorPalettePurple,
  ColorPaletteRed,
  ColorPaletteRoyal,
  ColorPaletteScarlet,
  ColorPaletteSky,
  ColorPaletteSteel,
  ColorPaletteSunshine,
  ColorPaletteTurquoise,
  ColorPaletteWhite,
  ColorPaymentPadBackgroundDark,
  ColorPaymentPadBackgroundLight,
  ColorPaymentPadBitcoinBackgroundDark,
  ColorPaymentPadBitcoinBackgroundLight,
  ColorPaymentPadBitcoinButtonBackgroundDark,
  ColorPaymentPadBitcoinButtonBackgroundLight,
  ColorPaymentPadButtonBackgroundDark,
  ColorPaymentPadButtonBackgroundLight,
  ColorPaymentPadGhostedTextDark,
  ColorPaymentPadGhostedTextLight,
  ColorPaymentPadKeyboardDark,
  ColorPaymentPadKeyboardLight,
  ColorTintGreenDark,
  ColorTintGreenLight,
  ColorTintVerificationDark,
  ColorTintVerificationLight,
  ColorUnselectedPasscodeDotDark,
  ColorUnselectedPasscodeDotLight,
  ColorWidgetForegroundDark,
  ColorWidgetForegroundLight,
  MotionCurveLongTail,
  MotionCurveStandard,
  MotionCurveSymmetrical,
  Space3xl,
  Space4xl,
  SpaceDefault,
  SpaceEmpty,
  SpaceInsetDefault,
  SpaceInsetL,
  SpaceInsetM,
  SpaceInsetS,
  SpaceInsetXl,
  SpaceInsetXs,
  SpaceInsetXxs,
  SpaceL,
  SpaceM,
  SpaceS,
  SpaceXl,
  SpaceXs,
  SpaceXxl,
  SpaceXxs,
  TypographyBigMoneyFontSize,
  TypographyBigMoneyFontWeight,
  TypographyBigMoneyLetterSpacing,
  TypographyBigMoneyLineHeight,
  TypographyCaptionFontSize,
  TypographyCaptionFontWeight,
  TypographyCaptionLetterSpacing,
  TypographyCaptionLineHeight,
  TypographyFontMedium,
  TypographyFontRegular,
  TypographyHeader1FontSize,
  TypographyHeader1FontWeight,
  TypographyHeader1LetterSpacing,
  TypographyHeader1LineHeight,
  TypographyHeader2FontSize,
  TypographyHeader2FontWeight,
  TypographyHeader2LetterSpacing,
  TypographyHeader2LineHeight,
  TypographyHeader3FontSize,
  TypographyHeader3FontWeight,
  TypographyHeader3LetterSpacing,
  TypographyHeader3LineHeight,
  TypographyHeader4FontSize,
  TypographyHeader4FontWeight,
  TypographyHeader4LetterSpacing,
  TypographyHeader4LineHeight,
  TypographyIdentifierFontSize,
  TypographyIdentifierFontWeight,
  TypographyIdentifierLetterSpacing,
  TypographyIdentifierLineHeight,
  TypographyIdentifierTextTransform,
  TypographyInputFontSize,
  TypographyInputFontWeight,
  TypographyInputLetterSpacing,
  TypographyInputLineHeight,
  TypographyMainBodyFontSize,
  TypographyMainBodyFontWeight,
  TypographyMainBodyLetterSpacing,
  TypographyMainBodyLineHeight,
  TypographyMainTitleFontSize,
  TypographyMainTitleFontWeight,
  TypographyMainTitleLetterSpacing,
  TypographyMainTitleLineHeight,
  TypographyRootFontSize,
  TypographySmallBodyFontSize,
  TypographySmallBodyFontWeight,
  TypographySmallBodyLetterSpacing,
  TypographySmallBodyLineHeight,
  TypographySmallTitleFontSize,
  TypographySmallTitleFontWeight,
  TypographySmallTitleLetterSpacing,
  TypographySmallTitleLineHeight,
  TypographyStrongCaptionFontSize,
  TypographyStrongCaptionFontWeight,
  TypographyStrongCaptionLetterSpacing,
  TypographyStrongCaptionLineHeight
};
//# sourceMappingURL=index.js.map